export const RECIPES_TOAST_ID = '__FIND_RECIPES__';

export const recipesMessages = {
  NO_RECIPES: "No recipes found. Please, update search params.",
  FETCHING_ERROR: "Error fetching data."
};

export const mealList = [
  {label: 'Any Meal', value: ''},
  {label: 'Appetizers', value: 'appetizer'},
  {label: 'Bread', value: 'bread'},
  {label: 'Breakfast', value: 'breakfast'},
  {label: 'Dessert', value: 'dessert'},
  {label: 'Main Dish', value: 'maindish'},
  {label: 'Salads', value: 'salad'},
  {label: 'Side Dish', value: 'sidedish'},
  {label: 'Soups', value: 'soup'},
  {label: 'Marinades', value: 'marinades'}
];

export const dietList = [
  {label: 'Any Diet', value: 'Any-Diet'},
  {label: 'Dairy Free', value: 'Dairy-Free'},
  {label: 'Diabetic', value: 'Diabetic'},
  {label: 'Gluten Free', value: 'Gluten-Free'},
  {label: 'Shellfish Free', value: 'Shellfish-Free'},
  {label: 'Low Calorie', value: 'Low-Calorie'},
  {label: 'Low Fat', value: 'Low-Fat'},
  {label: 'Low Sodium', value: 'Low-Sodium'},
  {label: 'Vegetarian', value: 'Vegetarian'},
  {label: 'Vegan', value: 'Vegan'},
  {label: 'Nut Free', value: 'Nut-Free'},
  {label: 'Paleo', value: 'Paleo'}
];

export const cuisineList = [
  {label: 'Any Cuisine', value: ''},
  {label: 'American', value: 'American'},
  {label: 'African', value: 'African'},
  {label: 'Asian', value: 'Asian'},
  {label: 'Cajun', value: 'Cajun'},
  {label: 'Chinese', value: 'Chinese'},
  {label: 'English', value: 'English'},
  {label: 'French', value: 'French'},
  {label: 'Greek', value: 'Greek'},
  {label: 'Indian', value: 'Indian'},
  {label: 'Italian', value: 'Italian'},
  {label: 'Japanese', value: 'Japanese'},
  {label: 'Jewish', value: 'Jewish'},
  {label: 'Korean', value: 'Korean'},
  {label: 'Middle Eastern', value: 'Middle+Eastern'},
  {label: 'Mexican', value: 'Mexican'},
  {label: 'Spanish', value: 'Spanish'},
  {label: 'Thai', value: 'Thai'},
  {label: 'Vietnamese', value: 'Vietnamese'},
];
